import type { DestructiveOpLastRun } from "@/lib/dashboardApi";
import { OperatorPanel } from "@/components/admin/dashboard/OperatorPanel";
import { fmtRelative } from "@/lib/relativeTime";

export function DestructiveOpsCard({
  data,
}: {
  data: DestructiveOpLastRun;
}): JSX.Element {
  const rows: Array<[string, string, { occurred_at: string | null } | null]> = [
    ["Prototype migration", "prototype_migration", data.prototype_migration],
    ["Tenant hard-delete", "tenant_hard_delete", data.tenant_hard_delete],
    ["Deletion reversal", "deletion_reversal", data.deletion_reversal],
  ];
  return (
    <OperatorPanel
      testId="platform-health-destructive-ops"
      kicker="Audit"
      title="Destructive ops — last run"
    >
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-text-secondary">
            <th className="pb-1 font-medium">Operation</th>
            <th className="pb-1 font-medium">Last run</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([label, key, evt]) => (
            <tr key={key} className="border-t border-border-default">
              <td className="py-1 text-text-primary">{label}</td>
              <td className="py-1 text-text-secondary">
                {evt?.occurred_at ? fmtRelative(evt.occurred_at) : "never"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </OperatorPanel>
  );
}
